// extracted by mini-css-extract-plugin
export default {"carouselVisibleVideo":"LivcorTheme_carouselVisibleVideo__jygC7","carouselHiddenVideo":"LivcorTheme_carouselHiddenVideo__muCl0"};